export const SpendGeographicGranularityTypes = ["all_geographies", "single_geography"] as const;

export type SpendGeographicGranularity = (typeof SpendGeographicGranularityTypes)[number];
